import { render, staticRenderFns } from "./maintenance.vue?vue&type=template&id=632ea5b9&"
import script from "./maintenance.vue?vue&type=script&lang=ts&"
export * from "./maintenance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports